__turbopack_context__.v({
  "container": "wPI5CG_container",
  "standard": "wPI5CG_standard",
  "summer": "wPI5CG_summer",
});
